/**
 * Features:
 * - §14.4.5 generic empty state: the open Collector's Journal with a pencil —
 *   used for empty lists (no requests yet, no history in range).
 */
import {
  ILLUSTRATION_ACCENT,
  PortalIllustration,
  type PortalIllustrationProps,
} from './portal-illustration';

type Props = Omit<PortalIllustrationProps, 'viewBox' | 'children'>;

export function EmptyStateIllustration(props: Props) {
  return (
    <PortalIllustration viewBox="0 0 120 90" {...props}>
      {/* open journal */}
      <path d="M60 22c-10-6-24-8-38-6v58c14-2 28 0 38 6 10-6 24-8 38-6V16c-14-2-28 0-38 6Z" />
      <path d="M60 22v58" />
      {/* page lines */}
      <path d="M30 30h20M30 38h20M30 46h14" />
      <path d="M70 30h20M70 38h20" />
      {/* pencil across the right page */}
      <path d="M76 66l16-16 6 6-16 16-8 2z" stroke={ILLUSTRATION_ACCENT} />
      <path d="M92 50l4-4a2.4 2.4 0 0 1 4 4l-4 4" stroke={ILLUSTRATION_ACCENT} />
      {/* desk line */}
      <path d="M14 84h92" />
    </PortalIllustration>
  );
}
